import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useQueryIntroducers } from 'lendingApi/lendingApiHooks';
import styles from './UserManagement.module.css';
import { UsersTable } from './UsersTable/UsersTable';

export const UserManagement = () => {
  const { introducerCompany } = useIntroducerData();
  const { data, isPending } = useQueryIntroducers({
    introducerAccountId: introducerCompany?.id ?? null,
  });

  return (
    <div className={styles.pageContent}>
      <h2 className={styles.heading}>User management</h2>
      {isPending && <p>Loading...</p>}
      {data && <UsersTable users={data.data.introducers} />}
    </div>
  );
};
